// extracted by mini-css-extract-plugin
export var contentarea = "ParagraphContentSection-module--contentarea--b3d59";
export var heading = "ParagraphContentSection-module--heading--118cb";
export var imagelayoutshiftblock = "ParagraphContentSection-module--imagelayoutshiftblock--9e596";
export var primary = "ParagraphContentSection-module--primary--b6c91";